import axios from "axios";
import { Urls } from "../../slices/urls";

export const fetchUserRepo = (data) => {
  return axios({
    method: "GET",
    // url: 'https://backend-service.careers360.de/api/1/auth/user/',
    url: Urls.USER_DETAIL_API,
    params: data,
  });
};
